import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';

import theme from '@theme/FolxTheme';

export const DashboardInfoSmallText = styled(BasicText)`
	font-size: 1.2rem;
	margin-bottom: 0.8rem;

	@media ${theme.responsive.breakpoints.tablet} {
		font-size: 1.6rem;
	}
`;
